import { useContext } from 'react';
import styled from 'styled-components';

import ScrollShadow from '../../../../components/ScrollShadow';
import { __ } from '../../../../i18n/l10n';
import { GRContext } from '../../contexts/GRContext';
import GRButton from '../GRButton/GRButton';

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;

  padding: 1em 2em;
`;

const RuleList = styled(ScrollShadow)`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;

  & > div {
    background-color: rgba(0, 51, 51, 0.6);
    border-radius: 1em;
    -webkit-backdrop-filter: blur(1.3em);
    backdrop-filter: blur(1.3em);
    height: auto;
  }

  & > * {
    padding: 1em;
  }
`;

const RuleListItem = styled.div`
  font-family: 'BettingTradeGothicLTStd';
  font-weight: bold;

  ::before {
    content: '• ';
  }

  & + & {
    margin-top: 1em;
  }
`;

const StyledGRButton = styled(GRButton)`
  margin-top: 1em;
`;

const GRLogo = styled.img`
  max-width: 90%;
  max-height: 30%;
  align-self: center;
  margin-bottom: 2em;
`;

type GRRuleProps = {
  className?: string;
  rules: Array<JSX.Element>;
  onFullRulesClick: () => void;
};

const GRRule = ({ className, rules, onFullRulesClick }: GRRuleProps) => {
  const { logoImgPath } = useContext(GRContext);

  return (
    <Wrapper className={className}>
      <GRLogo src={logoImgPath} />
      <RuleList>
        {rules.map((rule, idx) => (
          <RuleListItem key={`rule-list-item-${idx}`}>{rule}</RuleListItem>
        ))}
        <StyledGRButton onClick={onFullRulesClick}>{__('All rules')}</StyledGRButton>
      </RuleList>
    </Wrapper>
  );
};

export default GRRule;
